// Image Upload Types

export enum ImageType {
  BarbershopPhoto = 'BarbershopPhoto',
  ServicePhoto = 'ServicePhoto',
  BarberPhoto = 'BarberPhoto',
  UserAvatar = 'UserAvatar',
  CutHistoryPhoto = 'CutHistoryPhoto',
  GalleryPhoto = 'GalleryPhoto'
}

export interface ImageUpload {
  id: number;
  fileName: string;
  originalFileName: string;
  fileSize: number;
  contentType: string;
  imageType: ImageType;
  entityId: string;
  storageUrl: string;
  thumbnailUrl: string;
  uploadedBy: string;
  uploadedAt: string;
  width?: number;
  height?: number;
  isPrimary?: boolean;
}

export interface ImageUploadProgress {
  fileName: string;
  progress: number;
  status: 'uploading' | 'completed' | 'error';
  error?: string;
}
